import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import instance from "../../apis/youtube";
import Navbar from "../../Components/Navbar/Navbar";
import CourseCard from "../../Components/Courses/CourseCard";

export default function SearchPage() {
  const location = useLocation();
  const [params] = useSearchParams();
  const search = params.get("q") || location.state?.search || "";
  const [playlists, setPlaylists] = useState([]);
  const [status, setStatus] = useState("ready");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!search) return;
    const controller = new AbortController();
    setStatus("loading");
    instance
      .get("/search", {
        params: { q: search },
        signal: controller.signal,
        timeout: 20000,
      })
      .then(({ data }) => {
        setPlaylists(data.items || []);
        setStatus("ready");
      })
      .catch(() => {
        if (!controller.signal.aborted) setStatus("error");
      });
    return () => controller.abort();
  }, [search, attempt]);
  return (
    <>
      <Navbar />
      <main className="page-width page-main" id="main-content">
        <div className="page-heading">
          <p className="eyebrow">FOLLOW YOUR CURIOSITY</p>
          <h1>
            {search ? `Results for “${search}”` : "What’s your next chapter?"}
          </h1>
          <p>
            Discover playlists from educators on YouTube and make them part of
            your journey.
          </p>
        </div>
        {status === "loading" ? (
          <div className="empty-state surface" role="status">
            <span className="loading-ring" />
            <p>Looking for your next course…</p>
          </div>
        ) : status === "error" ? (
          <div className="empty-state surface" role="alert">
            <h3>Search is unavailable right now.</h3>
            <p>We couldn’t reach the course search. Please try again.</p>
            <button
              className="button button-secondary"
              onClick={() => setAttempt(attempt + 1)}
            >
              Try again
            </button>
          </div>
        ) : playlists.length ? (
          <>
            <p className="search-count">
              {playlists.length} playlists to explore
            </p>
            <div className="course-grid">
              {playlists.map((playlist) => (
                <CourseCard
                  key={playlist.id.playlistId}
                  course={{
                    playlistID: playlist.id.playlistId,
                    title: playlist.snippet.title,
                    description: playlist.snippet.description,
                    avatar:
                      playlist.snippet.thumbnails.high?.url ||
                      playlist.snippet.thumbnails.default?.url,
                  }}
                />
              ))}
            </div>
          </>
        ) : (
          <div className="empty-state surface">
            <MagnifyingGlassIcon />
            <h3>
              {search
                ? "A different search might do it."
                : "There’s a lot to discover."}
            </h3>
            <p>
              {search
                ? "Try a broader topic, like Python, design, or algorithms."
                : "Use the search in the navigation to find a course."}
            </p>
          </div>
        )}
      </main>
    </>
  );
}
